import dateFns from 'date-fns'

// URL list
import URL from '../../../config.url'


export default
{
    name: 'app-menu-match',

    props:
    {
        match: {type: Object, default: { }},
        contentGlobal: {type: Object, default: { }},
        hideScore: {type: Boolean, default: true},
        displayGame: {type: Boolean, default: false}
    },

    watch:
    {
        contentGlobal(content)
        {
            this._updateContent(content)
        }
    },

    data()
    {
        return {
            matchData: { }
        }
    },

    created()
    {
        this._updateContent(this.contentGlobal)
    },

    methods:
    {
        _updateContent(content)
        {
            const matchData = JSON.parse(JSON.stringify(this.match))

            const map = team =>
            {
                if (team.id === matchData.teamOneID)
                {
                    matchData.teamOne = team
                }
                else if (team.id === matchData.teamTwoID)
                {
                    matchData.teamTwo = team
                }
            }

            JSON.parse(JSON.stringify(content.teams)).forEach(map)

            this.matchData = matchData
        },

        _getLive()
        {
            const now = Math.round(new Date().getTime() / 1000)
            return now >= this.match.dateStart && this.match.status === 'pending'
        },

        _getLink()
        {
            if (this._getLive())
            {
                return this.$root.getPageURLFromID('watchNow')
            }
            else
            {
                return this.$root.getPageURLFromID('watchNow').replace(':slug', this.match.slug)
            }
        },

        _getBeginsDate()
        {
            const currentDate = Math.round(Date.now() / 1000)

            if (currentDate >= this.match.dateStart && this.match.status === 'pending')
            {
                return '<span class="u-color--red">' + this.contentGlobal.taxonomies.matches.live + '</span>'
            }
            else if (currentDate < this.match.dateStart)
            {
                if (dateFns.isSameDay(this.match.dateStart * 1000, currentDate * 1000))
                {
                    return this.contentGlobal.taxonomies.matches.beginsAt + ' ' + dateFns.format(this.match.dateStart * 1000, 'h[:]mm[<sup>]a[</sup>]')
                }
                else
                {
                    const daysDiff = dateFns.differenceInCalendarDays(this.match.dateStart * 1000, currentDate * 1000)

                    let diff
                    if (daysDiff > 1)
                    {
                        diff = daysDiff + ' ' + this.contentGlobal.taxonomies.words.days
                    }
                    else if (daysDiff > 0)
                    {
                        diff = daysDiff + ' ' + this.contentGlobal.taxonomies.words.day
                    }

                    return this.contentGlobal.taxonomies.matches.beginsIn + ' ' + diff
                }
            }

            return this.contentGlobal.taxonomies.matches.finished
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-menu-match/script.js